/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { signupSuccess } from 'services/api/users';

const Auth = ({ getProfileInfo }) => {
  const navigate = useNavigate();
  const { sessionId } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  useEffect(() => {
    localStorage.setItem('sessionId', sessionId);
    const isNewUser = searchParams.get('new') === 'true';
    const runAuth = async () => {
      if (isNewUser) {
        const gacid = localStorage.getItem('gacid');
        const gclid = localStorage.getItem('gclid');
        const fbclid = localStorage.getItem('fbclid');
        const params = {
          ...(gacid && { gacid }),
          ...(gclid && { gclid }),
          ...(fbclid && { fbclid }),
        };
        const hasGacid = gacid && gacid.length > 0;
        const hasGclid = gclid && gclid.length > 0;
        const hasFbclid = fbclid && fbclid.length > 0;
        if (hasGacid || hasGclid || hasFbclid) {
          try {
            await signupSuccess(params);
          } catch (e) {
            console.error(e);
          }
        }

      }
      await getProfileInfo();
      navigate(searchParams.get('next') || '/');
    };
    runAuth();
  }, []);
  return <div>Loading...</div>;
};

export default Auth;
